import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { getEnumValues } from "../utilities/enum";
import { SubscriptionStatus } from "../types/subscriptionTypes";

export interface EnumDropdownProps<E extends Record<keyof E, number | string>> {
  enumerable: E;
  enumDisplayName: Map<E[keyof E], string>;
  value: E[keyof E];
  setValue: (value: E[keyof E]) => void;
  className?: string;
  containerClassName?: string;
  isDevMode?: boolean;
}

const EnumDropdown = <E extends Record<keyof E, number | string>>({
  enumerable,
  enumDisplayName,
  value,
  setValue,
  className,
  containerClassName,
  isDevMode = false,
}: React.PropsWithChildren<EnumDropdownProps<E>>): React.ReactElement<EnumDropdownProps<E>> => {
  const disabledStatuses = [
    SubscriptionStatus.NEW,
    SubscriptionStatus.FAILED,
    SubscriptionStatus.PAUSED,
    ...(isDevMode ? [] : [SubscriptionStatus.EXPIRED]),
  ];

  return (
    <Dropdown className={containerClassName}>
      <Dropdown.Toggle as="p" className={`cursor-pointer ${className || ""}`}>
        {enumDisplayName.get(value)}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-z-index">
        {getEnumValues(enumerable)
          .filter((val) => enumDisplayName.get(val))
          .map((val) => (
            <Dropdown.Item
              key={val}
              onSelect={() => setValue(val)}
              disabled={disabledStatuses.includes(val as number)}
            >
              {enumDisplayName.get(val)}
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default EnumDropdown;
